<div class="container container-shadow pt-4 pb-5 my-4 mb-4">
  <h3 class="text-center">Intranets</h3>
  <div class="row">
    <div class="col-md-12">
      <a href="#" class="btn btn-primary m-2" type="button" (click)="goToRailsPage($event, '/intranets/new')">Add New Intranet</a>
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let intranet of intranets">
          <a href="#" (click)="goToRailsPage($event, '/intranets/' + intranet.id)">{{ intranet.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>
